// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { curtis as _curtis } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the curtis chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 33111
 * Chain Name: Curtis
 * Default Block Explorer: https://explorer.curtis.apechain.com
 * Default RPC URL: https://rpc.curtis.apechain.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { curtis } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: curtis,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const curtis = createCommon({
	..._curtis,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
